<p-dialog 
header="Registro de Firma" 
[(visible)]="displayModalFirma" 
(onHide)="closeModalFirma()" 
[modal]="true" 
[draggable]="false" 
[resizable]="false"
styleClass="p-dialog-firma-custom"
[style]="{width: '550px'}">
    <p-messages [(value)]="messagesErrorPrevious" 
    [enableService]="false" 
    [showTransitionOptions]="'500ms'" 
    [hideTransitionOptions]="'500ms'" 
    [closable]="true"></p-messages>
    <p *ngIf="nombreTrabajador">
      Está registrando la asistencia de <strong>{{nombreTrabajador}}</strong>
      para el estudio <strong>{{nombreEstudio}}</strong>  
    </p>
    <canvas id="cuadroFirma" #sigImg></canvas>
    <p-footer>
      <p-button (click)="callSignatureModal()">Firmar</p-button>
      <p-button (click)="closeModalFirma()" id="clean-button">Cancelar</p-button>
      <p-button (click)="onDone()">Confirmar</p-button>
    </p-footer>
</p-dialog>
